export default __webpack_public_path__ + "static/media/13 - Tentacle Summoning.6b37599a.png";